export default {
  "config": {
    "trial": "itc",
    "id": "patient-char",
    "type": "table",
    "title": "Patient Characteristics from 6 Randomized Controlled Trials of Adults with EDS Associated with OSA<sup>6</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "<sup>a</sup>Values were derived by censoring original clinical trial data at <no-break>20 minutes</no-break> to generate MWT20.",
      "<sup>b</sup>Values were derived by censoring original clinical trial data at <no-break>30 minutes</no-break> to generate MWT30."
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "itc",
    "id": "patient-char",
    "data-type": "table",
    "title": "Patient Characteristics from 6 Randomized Controlled Trials of Adults with EDS Associated with OSA<sup>6</sup>",
    "num-header-rows": 2,
    "num-columns": 18,
    "col-classes": [
      "col-1",
      "schw",
      "schw",
      "schw",
      "schw",
      "schw",
      "black",
      "black",
      "black",
      "hirsh",
      "hirsh",
      "inoue",
      "inoue",
      "pack",
      "pack",
      "roth",
      "roth",
      "roth"
    ],
    "row-mergeoption": [
      1,
      2
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1",
      "footnote-a",
      "footnote-b"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-a": "<sup>a</sup>Values were derived by censoring original clinical trial data at <no-break>20 minutes</no-break> to generate MWT20.",
    "footnote-b": "<sup>b</sup>Values were derived by censoring original clinical trial data at <no-break>30 minutes</no-break> to generate MWT30.",
    "data": {
      "row-0": [
        {
          "indent": 0,
          "content": "<b>Trial</b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Schweitzer, 2019</b><sup>23</sup></center>",
          "cols": 5,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "<center><b>Black, 2005</b><sup>3</sup></center>",
          "cols": 3,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "<center><b>Hirshkowitz, 2007</b><sup>11</sup></center>",
          "cols": 2,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": "<center><b>Inoue, 2013</b><sup>12</sup></center>",
          "cols": 2,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": "<center><b>Pack, 2001<sup>16</sup><br>Dinges, 2003<sup>8</sup></b></center>",
          "cols": 2,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": "<center><b>Roth, 2006<sup>20</sup></b></center>",
          "cols": 3,
          "class": "roth"
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "<b>Treatment arm</b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>Placebo</b>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol <no-break>37.5 mg qd</no-break></b>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol <no-break>75 mg qd</no-break></b>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol <no-break>150 mg qd</no-break></b>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol <no-break>300 mg qd</no-break></b>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "<b>Placebo</b>",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "<b>Modafinil <no-break>200 mg qd</no-break></b>",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "<b>Modafinil <no-break>400 mg qd</no-break></b>",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "<b>Placebo</b>",
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": "<b>Armodafinil <no-break>150 mg qd</no-break></b>",
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": "<b>Placebo</b>",
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": "<b>Modafinil <no-break>200 mg qd</no-break></b>",
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": "<b>Placebo</b>",
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": "<b>Modafinil <no-break>400 mg qd</no-break></b>",
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": "<b>Placebo</b>",
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": "<b>Armodafinil <no-break>150 mg qd</no-break></b>",
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": "<b>Armodafinil <no-break>250 mg qd</no-break></b>",
          "cols": 1,
          "class": "roth"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "N",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 119,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 58,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 62,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 117,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 118,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 104,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 104,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 101,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 130,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 129,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 62,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 52,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 80,
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 77,
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 130,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 131,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 131,
          "cols": 1,
          "class": "roth"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "Age, <no-break>mean, y<no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 54,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 57,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 54,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 53,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 53,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 51,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 48,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 49,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 51,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 51,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 51,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 49,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 50,
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 50,
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 50,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 49,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 49,
          "cols": 1,
          "class": "roth"
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "Age, <no-break>range, y<no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "50-74",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "33-72",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "29-74",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "21-75",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "24-72",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "28-68",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "24-68",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "28-70",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "25-68",
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": "27-69",
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": "28-72",
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": "32-76",
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "roth"
        }
      ],
      "row-5": [
        {
          "indent": 0,
          "content": "<no-break>Male, %</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 65,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 67,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 57,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 62,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 63,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 72,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 87,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 68,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 72,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 75,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 98,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 94,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 74,
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 79,
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 69,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 74,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 68,
          "cols": 1,
          "class": "roth"
        }
      ],
      "row-6": [
        {
          "indent": 0,
          "content": "<no-break>Caucasian, %</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 73,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 78,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 74,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 80,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 76,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 85,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 83,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 87,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 83,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 85,
          "cols": 1,
          "class": "roth"
        }
      ],
      "row-7": [
        {
          "indent": 0,
          "content": "BMI, <no-break>mean, kg/m<sup>2</sup></no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 33.1,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 34.1,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 33.4,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 33.3,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 32.9,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 37.3,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 36.2,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 36.9,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 30.8,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 36.3,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 27.3,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 27.9,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 35,
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 35.9,
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 37,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 36.6,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 36.5,
          "cols": 1,
          "class": "roth"
        }
      ],
      "row-8": [
        {
          "indent": 0,
          "content": "Baseline, ESS",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": 15.6,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 15.1,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 15,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 15.1,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 15.1,
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 14.7,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 15.8,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 14.8,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 16,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 15.6,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 14.6,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 14.3,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 14.4,
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 14.2,
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 15.9,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 15.4,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 15.3,
          "cols": 1,
          "class": "roth"
        }
      ],
      "row-9": [
        {
          "indent": 0,
          "content": "Baseline, MWT20",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "10.8<sup>a</sup>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "10.9<sup>a</sup>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "10.8<sup>a</sup>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "10.7<sup>a</sup>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "10.3<sup>a</sup>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": 13.8,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 13.1,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 13.5,
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 14.3,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": 14,
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "roth"
        }
      ],
      "row-10": [
        {
          "indent": 0,
          "content": "Baseline, MWT30",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "12.0<sup>b</sup>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "12.5<sup>b</sup>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "11.9<sup>b</sup>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "12.0<sup>b</sup>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "11.5<sup>b</sup>",
          "cols": 1,
          "class": "schw"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "black"
        },
        {
          "indent": 0,
          "content": 24.5,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": 24.2,
          "cols": 1,
          "class": "hirsh"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "inoue"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": "NR",
          "cols": 1,
          "class": "pack"
        },
        {
          "indent": 0,
          "content": 23.2,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 21.5,
          "cols": 1,
          "class": "roth"
        },
        {
          "indent": 0,
          "content": 23.3,
          "cols": 1,
          "class": "roth"
        }
      ]
    }
  }
};